import React, { useCallback } from 'react'
import styled from 'styled-components'

import useModal from 'hooks/useModal'
import { getTokenURL } from 'lottery/constants'
import Button from 'components/Button'
import WalletProviderModal from 'components/WalletProviderModal'

const GetTokenButton = ({href, text}) => {
  const [onPresentWalletProviderModal] = useModal(
    <WalletProviderModal />,
    'provider'
  )

  const handleUnlockClick = useCallback(() => {
    onPresentWalletProviderModal()
  }, [onPresentWalletProviderModal])

  return (
    <StyledAccountButton>
      <Button href={href || getTokenURL} size="sm" text={text} />
    </StyledAccountButton>
  )
}

const StyledAccountButton = styled.div`
  margin-right: 10px;
`

export default GetTokenButton
